import { Card, Descriptions } from 'antd'
import { useTranslation } from 'react-i18next'

import { formatKrw } from '@repo/shared'
import type { BuyerGroupSummary } from './buyerGroupSummary'

interface BuyerGroupSummaryCardProps {
  summary: BuyerGroupSummary
}

/** Totals for a buyer's new-order group — matches what the 신규주문 list row shows. */
export function BuyerGroupSummaryCard({ summary }: BuyerGroupSummaryCardProps) {
  const { t } = useTranslation()

  return (
    <Card
      title={t('pages.orders.groupSummary.title')}
      bordered
      data-testid="order-detail-group-summary"
    >
      <Descriptions column={1} size="small">
        <Descriptions.Item label={t('pages.orders.groupSummary.foCount')}>
          {t('pages.orders.foCount', { count: summary.fulfillmentOrderCount })}
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.orders.groupSummary.orderCount')}>
          {summary.orderCount === null
            ? '-'
            : t('pages.orders.compositionTotal', { count: summary.orderCount })}
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.orders.groupSummary.totalAmount')}>
          <strong data-testid="order-detail-group-total-amount">
            {summary.totalAmount === null ? '-' : formatKrw(summary.totalAmount)}
          </strong>
        </Descriptions.Item>
      </Descriptions>
    </Card>
  )
}
